import React, { useState, useContext, useEffect } from "react";
import { Nav, Badge, Offcanvas } from "react-bootstrap";
import { SlCalender } from "react-icons/sl";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import { useNavigate, Link } from "react-router-dom";
import {capitalizeFirstLetter } from "../../utils/Helper";

const NotificationDropdown = () => {
  const [show, setShow] = useState(false);
  const [notifications, setNotificationsdata] = useState([]);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDataNoti();
  }, []);

  const fetchDataNoti = async () => {
    try {
      const response = await APIServices.get(
        `admin/notifications/list`,
        headers
      );
      if (response?.status === 200) {
        const data1 = response?.data?.list || [];
        setNotificationsdata(data1);
        setCount(response?.data?.unreadCount);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setNotificationsdata([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setNotificationsdata([]);
    }
  };

  const handleOnClick = async (item) => {
    try {
      const payload = { id: item?.id };

      const response = await APIServices.post(
        `admin/notifications/mark_as_read`,
        payload,
        headers
      );
      if (response?.status === 200) {
        if (response?.data?.status === true) {
          navigate(`/admin/mom-details/${item.record_id}`);
          setShow(false)
          fetchDataNoti()
        }
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        console.error(
          response?.data?.message || "Something went wrong.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <Nav.Item>
        <Nav.Link
          className="notifiction position-relative"
          onClick={() => setShow(true)}
          style={{ cursor: "pointer" }}
        >
          <img src="/images/Bell_Bing.svg" className="img-fluid" alt="bell" />
          {count !== 0 && (<>
            <Badge pill className="position-absolute" bg="danger">
              {count}
            </Badge>
          </>
          )}
        </Nav.Link>
      </Nav.Item>

      <Offcanvas
        className="notificaion_canvas"
        show={show}
        onHide={() => setShow(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="font_blue_18 font-600">
            Notifications
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="list-group">
            {notifications.length === 0 ? (
              <li className="list-group-item">No notifications available.</li>
            ) : (
              notifications.map((item, index) => (
                <li
                  className={`list-group-item ${item.is_read == 0 ? 'cell-gray' : ''}`}
                  key={index}
                  onClick={() => handleOnClick(item)}
                >
                  <h3 className="font_blue_16 font-500">{capitalizeFirstLetter(item.subject)}</h3>
                  <p className="font_grey_12 mt-1">
                    <SlCalender className="me-2" />
                    {item.date_time}
                  </p>
                </li>
              ))
            )}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default NotificationDropdown;
